import { BID, RESUME_DRAFT, REMOVE_BID } from "./constants";

export const saveBid = (bidData) => async (dispatch) => {
  try {
    dispatch({
      type: BID,
      payload: bidData.bid,
    });

    dispatch({
      type: RESUME_DRAFT,
      payload: JSON.parse(bidData.result),
    });
  } catch (err) {
    console.log(err);
  }
};

export const removeBid = () => async (dispatch) => {
  try {
    dispatch({
      type: REMOVE_BID,
    });
  } catch (err) {
    console.log(err);
  }
};
